import React from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { MotionLazyContainer } from "./components/animate";
import Router from "./routes";
import { AuthProvider } from "./auth/JwtContext";
import { BitrixProvider } from "./context/BitrixContext";
import { ProjectsProvider } from "./context/ProjectsContext";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <MotionLazyContainer>
          <AuthProvider>
            <BitrixProvider>
              <ProjectsProvider>
                <Router />
              </ProjectsProvider>
            </BitrixProvider>
          </AuthProvider>
        </MotionLazyContainer>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
